export default {
	updateInvoicesCheckingUpdateOrganization(state, res) {
		state.InvoicesCheckingUpdate.removeAll();
		state.InvoicesCheckingUpdate = [...res];
		state.InvoicesCheckingUpdateTotal = res.length;
	},

	updateInvoicesCheckingUpdateSupplier(state, res) {
		state.InvoicesCheckingUpdate.removeAll();
		state.InvoicesCheckingUpdate = [...res];
		state.InvoicesCheckingUpdateTotal = res.length;
	}
};
